import { makeStyles } from '@material-ui/core/styles'

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
   backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}))
